import { type CSSProperties, useMemo } from 'react'
import { useSnapshot } from 'valtio'

import { QuadrantLink } from '@/components/QuadrantLink/QuadrantLink'
import { state } from '@/lib/state'
import { cn } from '@/lib/utils'
import type { Quadrant } from '../../../../types'
import styles from './Label.module.css'

interface LabelProps {
  quadrant: Quadrant
}

export function Label({ quadrant }: LabelProps) {
  const { radarConfig } = useSnapshot(state)
  const labels = radarConfig?.labels || {}
  const quadrantLabel = labels.quadrant

  const style = useMemo(
    () => ({ '--quadrant-color': quadrant.color }) as CSSProperties,
    [quadrant.color]
  )

  return (
    <div
      className={cn(styles.label, styles[`position-${quadrant.position}`])}
      style={style}
    >
      <div className={styles.header}>
        <span>
          {quadrantLabel} {quadrant.position}
        </span>
        <QuadrantLink quadrant={quadrant} />
      </div>
      <h3 className={styles.title}>{quadrant.title}</h3>
      <p className={styles.description}>{quadrant.description}</p>
    </div>
  )
}
